export default __webpack_public_path__ + "static/footer-bg-engineering-6d975875a44f9cbaead8ec578908248a.png";